"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.grabFromInfo = exports.elabMagicLink = exports.CrulesAPI = void 0;
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _NextApiClient = require("./NextApiClient");
var ResultManager = /*#__PURE__*/function () {
  function ResultManager() {
    (0, _classCallCheck2["default"])(this, ResultManager);
  }
  (0, _createClass2["default"])(ResultManager, null, [{
    key: "rowToRule",
    value: function rowToRule(row, json) {
      if (row.nl) row.rule.nl = row.nl;else row.rule.nl = 0;
      if (row.na) row.rule.na = row.na;else row.rule.na = 0;
      if (row.np) row.rule.np = row.np;else row.rule.np = 0;
      if (row.ul) row.rule.ul = row.ul;else row.rule.ul = 0;
      if (row.ua) row.rule.ua = row.ua;else row.rule.ua = 0;
      if (row.up) row.rule.up = row.up;else row.rule.up = 0;
      if (row.l) row.rule.l = row.l;else row.rule.l = 0;
      if (row.a) row.rule.a = row.a;else row.rule.a = 0;
      if (row.p) row.rule.p = row.p;else row.rule.p = 0;
      if (row.rule && row.rule.mergeHeaderRows && json.rule && json.rule.rows) row.rule.mergeHeaderRows(json.rule.rows);
    }
  }]);
  return ResultManager;
}();
var elabMagicLink = function elabMagicLink(extradata) {
  if (extradata.mLink) {
    if (!extradata.mLink.x1) extradata.mLink.x1 = 0;
    if (!extradata.mLink.y1) extradata.mLink.y1 = 0;
    if (!extradata.mLink.x2) extradata.mLink.x2 = 0;
    if (!extradata.mLink.y2) extradata.mLink.y2 = 0;
    if (!extradata.mLink.x3) extradata.mLink.x3 = 0;
    if (!extradata.mLink.y3) extradata.mLink.y3 = 0;
    if (!extradata.mLink.x4) extradata.mLink.x4 = 0;
    if (!extradata.mLink.y4) extradata.mLink.y4 = 0;
    if (!extradata.mLink.more) extradata.mLink.more = 0;
    if (!extradata.mLink.x5) extradata.mLink.x5 = 0;
    if (!extradata.mLink.y5) extradata.mLink.y5 = 0;
    if (!extradata.mLink.hTerra) extradata.mLink.hTerra = 0;
    if (!extradata.mLink.triangulate) extradata.mLink.triangulate = 0;
  }
};
exports.elabMagicLink = elabMagicLink;
var grabFromInfo = function grabFromInfo(newRow, rInfo) {
  if (rInfo.nl) newRow.nl = rInfo.nl;else newRow.nl = 0;
  if (rInfo.na) newRow.na = rInfo.na;else newRow.na = 0;
  if (rInfo.np) newRow.np = rInfo.np;else newRow.np = 0;
  if (rInfo.ul) newRow.ul = rInfo.ul;else newRow.ul = 0;
  if (rInfo.ua) newRow.ua = rInfo.ua;else newRow.ua = 0;
  if (rInfo.up) newRow.up = rInfo.up;else newRow.up = 0;
  if (rInfo.l) newRow.l = rInfo.l;else newRow.l = 0;
  if (rInfo.a) newRow.a = rInfo.a;else newRow.a = 0;
  if (rInfo.p) newRow.p = rInfo.p;else newRow.p = 0;
};
exports.grabFromInfo = grabFromInfo;
var checkObsolete = function checkObsolete(padre, optList) {
  if (!padre) return;
  if (padre.nodes) {
    for (var i = 0; i < padre.nodes.length; i++) {
      if (padre.nodes[i]) checkObsolete(padre.nodes[i], optList);
    }
  }
  var hasEnabled = false;
  (0, _forEach["default"])(optList).call(optList, function (x) {
    if (padre.cod === x.root) {
      if (x.enabletype !== 2) {
        hasEnabled = true;
      }
    }
  });
  if (padre.nodes) {
    for (var _i = 0; _i < padre.nodes.length; _i++) {
      if (!padre.nodes[_i].obsoleto) hasEnabled = true;
    }
  }
  if (!hasEnabled) {
    console.log("DISABLED", padre);
  }
  padre.obsoleto = !hasEnabled;
};
var CrulesAPI = /*#__PURE__*/function () {
  function CrulesAPI() {
    (0, _classCallCheck2["default"])(this, CrulesAPI);
  }
  (0, _createClass2["default"])(CrulesAPI, null, [{
    key: "getWallCat",
    value: function getWallCat() {
      var catalog = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "PARETI";
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      var params = {
        Catalogo: catalog
      };
      _NextApiClient.NextApiClient.com(this.service, "jWallcatget", params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        cbErr(err);
      });
    }
  }, {
    key: "loadItem",
    value: function loadItem(catalog, cmodel, item, lato) {
      var variants = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "";
      var header = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "";
      var cb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : function (j) {
        console.error(j);
      };
      var headerVar = "";
      if (variants && header) {
        headerVar += variants + ";" + header;
      } else if (header) {
        headerVar += header;
      } else if (variants) {
        headerVar += variants;
      }
      var params = {
        Catalogo: catalog,
        cModel: cmodel,
        Item: item,
        Lato: lato,
        Variants: headerVar,
        datalimits: 0
      };
      _NextApiClient.NextApiClient.com(this.service, "jLoadItemDt", params, function (json) {
        var response = {
          catalog: catalog,
          side: lato,
          l: json.l,
          a: json.a,
          p: json.p,
          model: json.model,
          cmodel: json.cModel,
          reg: json.reg,
          cod: json.item,
          des: json.desItem,
          modeldes: json.desModel,
          neutro: json.neutro,
          isloaditem: true,
          _configure: true,
          vheader: headerVar,
          primoCaricamento: "1",
          load: null,
          rule: json
        };
        if (cb) cb(response);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "loadRule",
    value: function loadRule(catalog) {
      var rule = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var variant = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      var cmodel = arguments.length > 3 ? arguments[3] : undefined;
      var item = arguments.length > 4 ? arguments[4] : undefined;
      var model = arguments.length > 5 ? arguments[5] : undefined;
      var neutro = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : "";
      var cb = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : function (j) {
        console.error(j);
      };
      var params = {
        Catalogo: catalog,
        Rule: rule,
        Variant: variant,
        cModel: cmodel,
        Item: item,
        Model: model,
        Neutro: neutro,
        datalimits: 0
      };
      _NextApiClient.NextApiClient.com(this.service, "jLoadRuleDt", params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        cbErr(err);
      });
    }
  }, {
    key: "rulePopVariant",
    value: function rulePopVariant(catalog, variant, data) {
      var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (j) {
        console.error(j);
      };
      if (!data.hasOwnProperty("force") || data.force !== 1) data.force = 1;
      var params = {
        Catalogo: catalog,
        Variant: variant,
        data: (0, _stringify["default"])(data)
      };
      _NextApiClient.NextApiClient.com(this.service, "jRulePopVariant", params, function (json) {
        if (json.tree) {
          for (var i = 0; i < json.tree.length; i++) checkObsolete(json.tree[i], json.d);
        }
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "rulePopVariantAllColumn",
    value: function rulePopVariantAllColumn(catalog, variant, data, allColumn) {
      var cb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function (j) {
        console.error(j);
      };
      if (!data.hasOwnProperty("force") || data.force !== 1) data.force = 1;
      var params = {
        Catalogo: catalog,
        Variant: variant,
        data: (0, _stringify["default"])(data),
        allColumn: allColumn
      };
      _NextApiClient.NextApiClient.com(this.service, "jRulePopVariantAllColumns", params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "ruleGetClosetVariants",
    value: function ruleGetClosetVariants(catalog, data, allColumn) {
      var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (j) {
        console.error(j);
      };
      if (!data.hasOwnProperty("force") || data.force !== 1) data.force = 1;
      var params = {
        Catalogo: catalog,
        data: (0, _stringify["default"])(data),
        allColumn: allColumn
      };
      _NextApiClient.NextApiClient.com(this.service, "jRuleGetClosetVariants", params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "ruleSetParam",
    value: function ruleSetParam(catalog, variant, data) {
      var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (j) {
        console.log(j);
      };
      data.force = 1;
      var params = {
        Catalogo: catalog,
        param: variant,
        data: (0, _stringify["default"])(data)
      };
      _NextApiClient.NextApiClient.com(this.service, "jRuleSetParam", params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "eval3D",
    value: function eval3D(catalog, rowId) {
      var firstLoad = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      var data = arguments.length > 3 ? arguments[3] : undefined;
      var options = arguments.length > 4 ? arguments[4] : undefined;
      var cb = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : function (j) {
        console.error(j);
      };
      var params = {
        Catalogo: catalog,
        boxId: rowId,
        primoCaricamento: firstLoad,
        data: (0, _stringify["default"])(data),
        options: options,
        datalimits: 0
      };
      _NextApiClient.NextApiClient.com(this.service, "jEval3D2", params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "evalDivider",
    value: function evalDivider(catalog, data, divider) {
      var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (j) {
        console.error(j);
      };
      var params = {
        Catalogo: catalog,
        data: (0, _stringify["default"])(data),
        divider: divider,
        datalimits: 0
      };
      _NextApiClient.NextApiClient.com(this.service, "jDividerSet", params, function (json) {
        if (json) {
          if (cb) cb(json);
        }
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "evalCloset",
    value: function evalCloset(catalog, rule, closetData) {
      var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (j) {
        console.error(j);
      };
      if (!closetData.hasOwnProperty('canEval')) closetData.canEval = false;
      var params = {
        Catalogo: catalog,
        rule: (0, _stringify["default"])(rule),
        closetVariants: (0, _stringify["default"])(closetData)
      };
      _NextApiClient.NextApiClient.com(this.service, "jEvalCloset", params, function (json) {
        if (json) {
          if (cb) cb(json);
        }
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "evalPlacer",
    value: function evalPlacer(prjRows, placerRowId) {
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.error(j);
      };
      var params = {
        prjRows: (0, _stringify["default"])(prjRows),
        placerRowID: placerRowId
      };
      _NextApiClient.NextApiClient.com(this.service, "jEvalPlacer", params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(cbErr);
      });
    }
  }, {
    key: "evalJob",
    value: function evalJob(data) {
      var machine = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.error(j);
      };
      var params = {
        data: (0, _stringify["default"])(data),
        machine: machine
      };
      _NextApiClient.NextApiClient.com(this.service, "jEvalJob", params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "currentAggAdd",
    value: function currentAggAdd(catalog) {
      var addCod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var data = arguments.length > 2 ? arguments[2] : undefined;
      var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (j) {
        console.error(j);
      };
      var params = {
        Catalogo: catalog,
        aggiunta: addCod || "",
        data: (0, _stringify["default"])(data)
      };
      _NextApiClient.NextApiClient.com(this.service, "jCurrentAggAdd", params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "currentAggRemove",
    value: function currentAggRemove(catalog, id, data) {
      var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (j) {
        console.error(j);
      };
      var params = {
        Catalogo: catalog,
        position: id || "",
        data: (0, _stringify["default"])(data)
      };
      _NextApiClient.NextApiClient.com(this.service, "jCurrentAggRemove", params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "initApplica",
    value: function initApplica(catalog, cmodel, variant) {
      var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (j) {
        console.error(j);
      };
      var params = {
        Catalogo: catalog,
        cModel: cmodel,
        Variant: variant,
        datalimits: 0
      };
      _NextApiClient.NextApiClient.com(this.service, "jInitApplica", params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "headerSet",
    value: function headerSet(data) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      _NextApiClient.NextApiClient.com(this.service, "jHeaderSet", data, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "eval3D_WALLS",
    value: function eval3D_WALLS(wallVector, project, windowInstance) {
      var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (j) {
        console.error(j);
      };
      var params = {
        wallVector: wallVector,
        project: project,
        windowInstance: windowInstance
      };
      _NextApiClient.NextApiClient.com(this.service, "jEval3D_WALLS", params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "cadCallbackScriptQuote",
    value: function cadCallbackScriptQuote(data) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      if (data && data.callbackDone) {
        _NextApiClient.NextApiClient.com(this.service, "jEvalScriptQuote", {
          Catalogo: data.catalogo,
          data: (0, _stringify["default"])(data.scrJsx)
        }, function (d) {
          data.callbackDone(d);
        }, function (d) {
          data.callbackDone(d);
        });
      }
    }
  }, {
    key: "cadCallBackEvalWallsFromProject",
    value: function cadCallBackEvalWallsFromProject(project) {
      var cbDone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      var data = {};
      data.project = project;
      data.callbackDone = cbDone;
      data.callbackError = cbErr;
      CrulesAPI.cadCallBackEvalWalls(data);
    }
  }, {
    key: "cadCallBackEvalWalls",
    value: function cadCallBackEvalWalls(data) {
      if (data && data.project) {
        var wallVector = (0, _stringify["default"])(data.project.envWall.wallsVector);
        var windowInstance = (0, _stringify["default"])(data.project.envWall.windowInstance);
        CrulesAPI.eval3D_WALLS(wallVector, (0, _stringify["default"])(data.project.envWall.wallsProject), windowInstance, function (d) {
          data.callbackDone(d);
        }, function (d) {
          data.callbackError(d);
        });
      } else console.warn("Eng3d_Callbacks.CB_EVALUATE_WALLS missing project");
    }
  }, {
    key: "jEvalTop2",
    value: function jEvalTop2(data, _final, dumpmsg) {
      var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (j) {
        console.error(j);
      };
      var params = {
        data: data,
        "final": _final,
        dumpmsg: dumpmsg
      };
      _NextApiClient.NextApiClient.com(this.service, "jEvalTop2", params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "calcolaRivaluta",
    value: function calcolaRivaluta(evalPrjData) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      var _final2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
      if (evalPrjData.rows.length) {
        this.jEvalTop2((0, _stringify["default"])(evalPrjData), _final2, 0, cb, cbErr);
      } else {
        if (cb) cb(null);
      }
    }
  }, {
    key: "ruleSetParamBlob",
    value: function ruleSetParamBlob(catalog, data, blobParams) {
      var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (j) {
        console.log(j);
      };
      data.force = 1;
      var params = {
        Catalogo: catalog,
        rule_data: (0, _stringify["default"])(data),
        data: (0, _stringify["default"])(blobParams)
      };
      _NextApiClient.NextApiClient.com(this.service, "jRuleSetParamBlob", params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "evalPan",
    value: function evalPan(data) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var params = {
        data: (0, _stringify["default"])(data)
      };
      _NextApiClient.NextApiClient.com(this.service, "jEvalPan", params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }]);
  return CrulesAPI;
}();
exports.CrulesAPI = CrulesAPI;
CrulesAPI.service = "crules";
CrulesAPI.grabFromInfo = grabFromInfo;
CrulesAPI.elabMagicLink = elabMagicLink;
//# sourceMappingURL=CrulesAPI.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/api/CrulesAPI.js
// module id = 1216
// module chunks = 142